module.exports = __webpack_public_path__ + "static/media/60.8655651f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/poinkos/60.jpg
// module id = 593
// module chunks = 0